<template>
    <div class="box-page">
        <div class="col-12 pl-0 pr-0">
            <div class="col-12 pl-0 pr-0 d-md-flex">
                <div class="col-12 col-md-10 pl-0 pr-0 pr-md-3">
                    <div class="col-12 pl-2 pr-2 pl-md-3 pr-md-3 bg-white rounded-cus cus-box-shadow">
                        <div class="col-12 pt-3 pb-3 pl-2 pr-2 filter-title cursor-pointer" data-toggle="collapse" data-target="#filterReport"
                            @click="toggleFilter" :class="tfilter == true ? 'active' : ''">
                            <div class="col-6 pl-0 mt-auto mb-auto">
                                <div class="col-12 pl-0 pr-0 font-size-10"><span class="mr-2"><i class="fas fa-filter"></i></span>Filter</div>
                            </div>
                        </div>
                        <div id="filterReport" class="collapse">
                            <div class="col-12 pb-3 pl-2 pr-2 font-size-10">
                                <div class="col-12 pl-0 pr-0 d-flex">
                                    <div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Pilih Jenis Laporan</div>
                                    <div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
                                        <v-select v-model="tipe.value" :options="dateType" label="name" :reduce="el => el.value"
                                            class="font-size-9 w-100">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-12 pt-2 pl-0 pr-0 d-flex" v-if="tipe.value == 1">
                                    <div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Tanggal</div>
                                    <div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
                                        <div class="col-6 pl-0 pr-2">
                                            <datetime input-id="tanggalAwal" :max-datetime="maxDate"
                                                :min-datetime="new Date('2000-01-01').toISOString()" class="theme-purple"
                                                input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9"
                                                placeholder="Dari Tanggal" v-model="tanggalAwal"></datetime>
                                        </div>
                                        <div class="col-6 pl-0 pr-0">
                                            <datetime input-id="tanggalAkhir" :max-datetime="today" :min-datetime="minDate" class="theme-purple"
                                                input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9"
                                                placeholder="Sampai Tanggal" v-model="tanggalAkhir"></datetime>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 pl-0 pr-0 pt-2 d-flex flex-wrap">
                                    <div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Kode Produk</div>
                                    <div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
                                        <v-select v-model="product.value" :options="dataProduct" label="product_code" title="Pilih Produk"
                                            class="font-size-9 w-100" :reduce="el => el.product_code">
                                            <template v-slot:no-options>
                                                Saat ini tidak Produk tersedia
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                {{ option.product_code }} - {{ option.product_name }}
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                {{ option.product_code }} - {{ option.product_name }}
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="col-5 d-lg-none"></div>
                                    <div class="col-12 col-md-7 col-lg-4 d-flex pl-0 pl-lg-3 pr-0 pr-lg-3 pt-3 pt-lg-0">
                                        <div class="col-6 pl-0 pr-2 pr-md-3">
                                            <button class="col-12 pt-1 pb-1 btn btn-outline-danger rounded-cus no-box-focus" @click="reset"><span
                                                    class="font-size-9">Reset</span></button>
                                        </div>
                                        <div class="col-6 pl-0 pr-0 pr-md-2 pr-lg-3">
                                            <button class="col-12 pt-1 pb-1 btn btn-blue rounded-cus no-box-focus" @click="cari"><span
                                                    class="font-size-9">Cari</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- DISINI -->
                    <div class="alert alert-primary mb-0 mt-3 font-size-10" role="alert">
                        Untuk data <a class="font-italic">Total Modal Produk</a>, hanya relevan untuk transaksi mulai 24 Januari 2025
                    </div>
                    <div class="col-12 pl-0 pr-0">
                        <div class="row">
                            <div class="col-12 d-flex flex-wrap pt-3">
                                <div class="col-12 pt-3 pb-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
                                    <div class="col-12 pl-2 color-blue font-weight-bold font-size-14">Analisa Penjualan</div>
                                    <div class="col-12 pl-2 pt-3 font-size-12" v-if="dataAnalysis.title != ''">{{ dataAnalysis.title }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 pr-0 d-flex flex-wrap" v-if="Object.values(dataAnalysis).length == 0">
                                <div class="col-12 col-md-6 col-lg-6 pl-0 pt-3" v-for="(index) in 6" :key="index">
                                    <div class="col-12 pt-3 pb-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
                                        <vcl :width='300' :height='100'>
                                            <rect x="1" y="2" rx="2" ry="2" width="140" height="15" />
                                            <rect x="1" y="25" rx="2" ry="2" width="100" height="13" />
                                            <rect x="1" y="65" rx="2" ry="2" width="70" height="13" />
                                            <rect x="1" y="85" rx="2" ry="2" width="70" height="10" />
                                        </vcl>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 pr-0 d-flex flex-wrap" v-if="Object.values(dataAnalysis).length > 0">
                                <div class="col-12 col-md-6 col-lg-6 pl-0 pt-3">
                                    <div class="col-12 pt-3 pb-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
                                        <div class="col-12 pl-2 color-blue font-weight-bold font-size-14">Total Penjualan</div>
                                        <template
                                            v-if="dataAnalysis.total_sales_price.price > 0 || dataAnalysis.total_sales_price.price_before > 0">
                                            <div class="col-12 pl-2">{{ dataAnalysis.total_sales_price.price | toRupiah }}</div>
                                            <div class="col-12 pl-2 pt-4 font-weight-bold d-flex"
                                                :class="dataAnalysis.total_sales_price.percentage > 0 ? 'color-green' : dataAnalysis.total_sales_price.percentage < 0 ? 'color-red' : ''">
                                                <div v-if="dataAnalysis.total_sales_price.percentage > 0" class="img-fluid pr-1">
                                                    <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"
                                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px">
                                                        <path fill="#2ecc71"
                                                            d="m9.001 10.978h-3.251c-.412 0-.75-.335-.75-.752 0-.188.071-.375.206-.518 1.685-1.775 4.692-4.945 6.069-6.396.189-.2.452-.312.725-.312.274 0 .536.112.725.312 1.377 1.451 4.385 4.621 6.068 6.396.136.143.207.33.207.518 0 .417-.337.752-.75.752h-3.251v9.02c0 .531-.47 1.002-1 1.002h-3.998c-.53 0-1-.471-1-1.002z"
                                                            fill-rule="nonzero" transform="translate(0,-3)" />
                                                    </svg>
                                                </div>
                                                <div v-else-if="dataAnalysis.total_sales_price.percentage < 0" class="img-fluid pr-1">
                                                    <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"
                                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px">
                                                        <path fill="#d63031"
                                                            d="m9.001 13.022h-3.251c-.412 0-.75.335-.75.752 0 .188.071.375.206.518 1.685 1.775 4.692 4.945 6.069 6.396.189.2.452.312.725.312.274 0 .536-.112.725-.312 1.377-1.451 4.385-4.621 6.068-6.396.136-.143.207-.33.207-.518 0-.417-.337-.752-.75-.752h-3.251v-9.02c0-.531-.47-1.002-1-1.002h-3.998c-.53 0-1 .471-1 1.002z"
                                                            fill-rule="nonzero" transform="translate(0,-2)" />
                                                    </svg>
                                                </div>
                                                <template v-if="dataAnalysis.total_sales_price.percentage != 0">
                                                    {{ dataAnalysis.total_sales_price.percentage }}%
                                                </template>
                                                <template v-else>
                                                    -
                                                </template>
                                            </div>
                                            <div class="col-12 pl-2 font-size-10">vs {{ dataAnalysis.total_sales_price.price_before | toRupiah }}
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="col-12 pl-2 pt-4">Tidak ada data</div>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-6 pl-0 pt-3">
                                    <div class="col-12 pt-3 pb-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
                                        <div class="col-12 pl-2 color-blue font-weight-bold font-size-14">Total Modal Produk</div>
                                        <template
                                            v-if="dataAnalysis.total_sales_price_original.price > 0 || dataAnalysis.total_sales_price_original.price_before > 0">
                                            <div class="col-12 pl-2">{{ dataAnalysis.total_sales_price_original.price | toRupiah }}</div>
                                            <div class="col-12 pl-2 pt-4 font-weight-bold d-flex"
                                                :class="dataAnalysis.total_sales_price_original.percentage > 0 ? 'color-green' : dataAnalysis.total_sales_price_original.percentage < 0 ? 'color-red' : ''">
                                                <div v-if="dataAnalysis.total_sales_price_original.percentage > 0" class="img-fluid pr-1">
                                                    <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"
                                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px">
                                                        <path fill="#2ecc71"
                                                            d="m9.001 10.978h-3.251c-.412 0-.75-.335-.75-.752 0-.188.071-.375.206-.518 1.685-1.775 4.692-4.945 6.069-6.396.189-.2.452-.312.725-.312.274 0 .536.112.725.312 1.377 1.451 4.385 4.621 6.068 6.396.136.143.207.33.207.518 0 .417-.337.752-.75.752h-3.251v9.02c0 .531-.47 1.002-1 1.002h-3.998c-.53 0-1-.471-1-1.002z"
                                                            fill-rule="nonzero" transform="translate(0,-3)" />
                                                    </svg>
                                                </div>
                                                <div v-if="dataAnalysis.total_sales_price_original.percentage < 0" class="img-fluid pr-1">
                                                    <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"
                                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px">
                                                        <path fill="#d63031"
                                                            d="m9.001 13.022h-3.251c-.412 0-.75.335-.75.752 0 .188.071.375.206.518 1.685 1.775 4.692 4.945 6.069 6.396.189.2.452.312.725.312.274 0 .536-.112.725-.312 1.377-1.451 4.385-4.621 6.068-6.396.136-.143.207-.33.207-.518 0-.417-.337-.752-.75-.752h-3.251v-9.02c0-.531-.47-1.002-1-1.002h-3.998c-.53 0-1 .471-1 1.002z"
                                                            fill-rule="nonzero" transform="translate(0,-2)" />
                                                    </svg>
                                                </div>
                                                <template v-if="dataAnalysis.total_sales_price_original.percentage != 0">
                                                    {{ dataAnalysis.total_sales_price_original.percentage }}%
                                                </template>
                                                <template v-else>
                                                    -
                                                </template>
                                            </div>
                                            <div class="col-12 pl-2 font-size-10">vs {{ dataAnalysis.total_sales_price_original.price_before |
                                                toRupiah }}</div>
                                        </template>
                                        <template v-else>
                                            <div class="col-12 pl-2 pt-4">Tidak ada data</div>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-6 pl-0 pt-3">
                                    <div class="col-12 pt-3 pb-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
                                        <div class="col-12 pl-2 color-blue font-weight-bold font-size-14">Total Laba Bersih</div>
                                        <template
                                            v-if="dataAnalysis.total_sales_diff.price > 0 || dataAnalysis.total_sales_diff.price_before > 0">
                                            <div class="col-12 pl-2">{{ dataAnalysis.total_sales_diff.price | toRupiah }}</div>
                                            <div class="col-12 pl-2 pt-4 font-weight-bold d-flex"
                                                :class="dataAnalysis.total_sales_diff.percentage > 0 ? 'color-green' : dataAnalysis.total_sales_diff.percentage < 0 ? 'color-red' : ''">
                                                <div v-if="dataAnalysis.total_sales_diff.percentage > 0" class="img-fluid pr-1">
                                                    <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"
                                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px">
                                                        <path fill="#2ecc71"
                                                            d="m9.001 10.978h-3.251c-.412 0-.75-.335-.75-.752 0-.188.071-.375.206-.518 1.685-1.775 4.692-4.945 6.069-6.396.189-.2.452-.312.725-.312.274 0 .536.112.725.312 1.377 1.451 4.385 4.621 6.068 6.396.136.143.207.33.207.518 0 .417-.337.752-.75.752h-3.251v9.02c0 .531-.47 1.002-1 1.002h-3.998c-.53 0-1-.471-1-1.002z"
                                                            fill-rule="nonzero" transform="translate(0,-3)" />
                                                    </svg>
                                                </div>
                                                <div v-if="dataAnalysis.total_sales_diff.percentage < 0" class="img-fluid pr-1">
                                                    <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"
                                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px">
                                                        <path fill="#d63031"
                                                            d="m9.001 13.022h-3.251c-.412 0-.75.335-.75.752 0 .188.071.375.206.518 1.685 1.775 4.692 4.945 6.069 6.396.189.2.452.312.725.312.274 0 .536-.112.725-.312 1.377-1.451 4.385-4.621 6.068-6.396.136-.143.207-.33.207-.518 0-.417-.337-.752-.75-.752h-3.251v-9.02c0-.531-.47-1.002-1-1.002h-3.998c-.53 0-1 .471-1 1.002z"
                                                            fill-rule="nonzero" transform="translate(0,-2)" />
                                                    </svg>
                                                </div>
                                                <template v-if="dataAnalysis.total_sales_diff.percentage != 0">
                                                    {{ dataAnalysis.total_sales_diff.percentage }}%
                                                </template>
                                                <template v-else>
                                                    -
                                                </template>
                                            </div>
                                            <div class="col-12 pl-2 font-size-10">vs {{ dataAnalysis.total_sales_diff.price_before | toRupiah }}
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="col-12 pl-2 pt-4">Tidak ada data</div>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-6 pl-0 pt-3">
                                    <div class="col-12 pt-3 pb-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
                                        <div class="col-12 pl-2 color-blue font-weight-bold font-size-14">Jumlah Transaksi</div>
                                        <template
                                            v-if="dataAnalysis.total_transaction.transaction > 0 || dataAnalysis.total_transaction.transaction_before > 0">
                                            <div class="col-12 pl-2">{{ dataAnalysis.total_transaction.transaction }} Kali</div>
                                            <div class="col-12 pl-2 pt-4 font-weight-bold d-flex"
                                                :class="dataAnalysis.total_transaction.percentage > 0 ? 'color-green' : dataAnalysis.total_transaction.percentage < 0 ? 'color-red' : ''">
                                                <div v-if="dataAnalysis.total_transaction.percentage > 0" class="img-fluid pr-1">
                                                    <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"
                                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px">
                                                        <path fill="#2ecc71"
                                                            d="m9.001 10.978h-3.251c-.412 0-.75-.335-.75-.752 0-.188.071-.375.206-.518 1.685-1.775 4.692-4.945 6.069-6.396.189-.2.452-.312.725-.312.274 0 .536.112.725.312 1.377 1.451 4.385 4.621 6.068 6.396.136.143.207.33.207.518 0 .417-.337.752-.75.752h-3.251v9.02c0 .531-.47 1.002-1 1.002h-3.998c-.53 0-1-.471-1-1.002z"
                                                            fill-rule="nonzero" transform="translate(0,-3)" />
                                                    </svg>
                                                </div>
                                                <div v-if="dataAnalysis.total_transaction.percentage < 0" class="img-fluid pr-1">
                                                    <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"
                                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px">
                                                        <path fill="#d63031"
                                                            d="m9.001 13.022h-3.251c-.412 0-.75.335-.75.752 0 .188.071.375.206.518 1.685 1.775 4.692 4.945 6.069 6.396.189.2.452.312.725.312.274 0 .536-.112.725-.312 1.377-1.451 4.385-4.621 6.068-6.396.136-.143.207-.33.207-.518 0-.417-.337-.752-.75-.752h-3.251v-9.02c0-.531-.47-1.002-1-1.002h-3.998c-.53 0-1 .471-1 1.002z"
                                                            fill-rule="nonzero" transform="translate(0,-2)" />
                                                    </svg>
                                                </div>
                                                <template v-if="dataAnalysis.total_transaction.percentage != 0">
                                                    {{ dataAnalysis.total_transaction.percentage }}%
                                                </template>
                                                <template v-else>
                                                    -
                                                </template>
                                            </div>
                                            <div class="col-12 pl-2 font-size-10">vs {{ dataAnalysis.total_transaction.transaction_before }} Kali
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="col-12 pl-2 pt-4">Tidak ada data</div>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-6 pl-0 pt-3">
                                    <div class="col-12 pt-3 pb-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
                                        <div class="col-12 pl-2 color-blue font-weight-bold font-size-14">Rata - rata Transaksi</div>
                                        <template
                                            v-if="dataAnalysis.total_avg_sales_price.price > 0 || dataAnalysis.total_avg_sales_price.price_before > 0">
                                            <div class="col-12 pl-2">{{ dataAnalysis.total_avg_sales_price.price | toRupiah }}</div>
                                            <div class="col-12 pl-2 pt-4 font-weight-bold d-flex"
                                                :class="dataAnalysis.total_avg_sales_price.percentage > 0 ? 'color-green' : dataAnalysis.total_avg_sales_price.percentage < 0 ? 'color-red' : ''">
                                                <div v-if="dataAnalysis.total_avg_sales_price.percentage > 0" class="img-fluid pr-1">
                                                    <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"
                                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px">
                                                        <path fill="#2ecc71"
                                                            d="m9.001 10.978h-3.251c-.412 0-.75-.335-.75-.752 0-.188.071-.375.206-.518 1.685-1.775 4.692-4.945 6.069-6.396.189-.2.452-.312.725-.312.274 0 .536.112.725.312 1.377 1.451 4.385 4.621 6.068 6.396.136.143.207.33.207.518 0 .417-.337.752-.75.752h-3.251v9.02c0 .531-.47 1.002-1 1.002h-3.998c-.53 0-1-.471-1-1.002z"
                                                            fill-rule="nonzero" transform="translate(0,-3)" />
                                                    </svg>
                                                </div>
                                                <div v-if="dataAnalysis.total_avg_sales_price.percentage < 0" class="img-fluid pr-1">
                                                    <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"
                                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px">
                                                        <path fill="#d63031"
                                                            d="m9.001 13.022h-3.251c-.412 0-.75.335-.75.752 0 .188.071.375.206.518 1.685 1.775 4.692 4.945 6.069 6.396.189.2.452.312.725.312.274 0 .536-.112.725-.312 1.377-1.451 4.385-4.621 6.068-6.396.136-.143.207-.33.207-.518 0-.417-.337-.752-.75-.752h-3.251v-9.02c0-.531-.47-1.002-1-1.002h-3.998c-.53 0-1 .471-1 1.002z"
                                                            fill-rule="nonzero" transform="translate(0,-2)" />
                                                    </svg>
                                                </div>
                                                <template v-if="dataAnalysis.total_avg_sales_price.percentage != 0">
                                                    {{ dataAnalysis.total_avg_sales_price.percentage }}%
                                                </template>
                                                <template v-else>
                                                    -
                                                </template>
                                            </div>
                                            <div class="col-12 pl-2 font-size-10">vs {{ dataAnalysis.total_avg_sales_price.price_before |
                                                toRupiah }}</div>
                                        </template>
                                        <template v-else>
                                            <div class="col-12 pl-2 pt-4">Tidak ada data</div>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-6 pl-0 pt-3">
                                    <div class="col-12 pt-3 pb-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
                                        <div class="col-12 pl-2 color-blue font-weight-bold font-size-14">Produk Terlaris</div>
                                        <template v-if="dataAnalysis.most_sales.total_sales > 0">
                                            <div class="col-12 pl-2">{{ dataAnalysis.most_sales.product_code }}</div>
                                            <div class="col-12 pl-2">{{ dataAnalysis.most_sales.product_name }}</div>
                                            <div class="col-12 pl-2 pt-4 font-size-10">Terjual {{ dataAnalysis.most_sales.total_sales + ' ' +
                                                dataAnalysis.most_sales.product_unit }}</div>
                                        </template>
                                        <template v-else>
                                            <div class="col-12 pl-2 pt-4">Tidak ada data</div>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-6 pl-0 pt-3">
                                    <div class="col-12 pt-3 pb-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
                                        <div class="col-12 pl-2 color-blue font-weight-bold font-size-14">Pelanggan Utama</div>
                                        <template v-if="dataAnalysis.most_buyer.buyer_name != ''">
                                            <div class="col-12 pl-2">{{ dataAnalysis.most_buyer.buyer_name }}</div>
                                            <div class="col-12 pl-2 pt-3">{{ dataAnalysis.most_buyer.transaction }} Transaksi</div>
                                            <div class="col-12 pl-2">{{ dataAnalysis.most_buyer.buyer_transaction | toRupiah }}</div>
                                        </template>
                                        <template v-else>
                                            <div class="col-12 pl-2 pt-4">Tidak ada data</div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
    components: {
        // RChart,
        // IPagination,
    },
    name: 'Report',
    data() {
        return {
            dateType: [{ value: '', name: 'Pilih Jenis Laporan' }, { value: '1', name: 'Pilih Tanggal' }, { value: '2', name: 'Hari ini' }, { value: '3', name: 'Minggu ini' }, { value: '4', name: 'Bulan ini' }, { value: '5', name: 'Tahun ini' },],
            tanggalAwal: "",
            tanggalAkhir: "",
            tfilter: false,
            today: new Date().toISOString(),
            limit: 10,
            tanggal: {
                value: '',
                comparison: 'bet',
                type: 'date',
                field: 'trx_datetime'
            },
            kode: {
                value: '',
                comparison: 'LIKE',
                type: 'string',
                field: 'trx_code'
            },
            tipe: {
                value: '2',
                comparison: '=',
                type: 'numeric',
                field: 'date_type'
            },
            name: {
                value: '',
                comparison: 'LIKE',
                type: 'string',
                field: 'trx_buyer_name'
            },
            mid: {
                value: '',
                comparison: '=',
                type: 'string',
                field: 'trx_buyer_sponsor_network_mid'
            },
            product: {
                value: 'Pilih Produk',
                comparison: '=',
                type: 'string',
                field: 'product_code'
            },
            params: {},
            rangeLaporan: '',
            page: 1
        }
    },
    methods: {
        cari() {
            this.params = []
            this.page = 1
            let productCode = '';
            let dateRange = '';
            if (this.tipe.value == 1) {
                if (!this.tanggalAkhir) {
                    this.tanggalAkhir = this.tanggalAwal
                }
                if (this.tanggalAkhir == this.tanggalAwal) {
                    this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY')
                } else {
                    this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY') + ' s.d ' + moment(this.tanggalAkhir).format('Do MMMM YYYY')
                }
                if (this.tanggalAwal && this.tanggalAkhir) {
                    this.tanggal.value = moment(this.tanggalAwal).format('YYYY-MM-DD') + "::" + moment(this.tanggalAkhir).format('YYYY-MM-DD')
                    // this.params.push(this.tanggal)
                    dateRange = this.tanggal.value
                } else {
                    this.rangeLaporan = ''
                }
            }
            if (this.tipe.value) {
                let date = new Date();
                this.tanggal.value = moment(date).format('YYYY-MM-DD')
                this.params.push({
                    value: this.tanggal.value,
                    comparison: '=',
                    type: 'date',
                    field: 'trx_datetime'
                })
            }

            if (this.product.value != 'Pilih Produk') {
                productCode = this.product.value
            }
            this.getSalesAnalysis({ params: this.params, dateType: this.tipe.value, productCode: productCode, dateRange: dateRange })
        },
        reset() {
            this.tipe.value = '2'
            this.kode.value = ''
            this.name.value = ''
            this.mid.value = ''
            this.product.value = 'Pilih Produk'
            this.tanggal.value = ''
            this.rangeLaporan = ''
            this.tanggalAwal = ''
            this.tanggalAkhir = ''
            this.page = 1
            this.params = []
            this.params.push(this.tipe)
            this.params.push(this.product)
            this.getSalesAnalysis({ params: this.params, dateType: this.tipe.value, productCode: this.product.value })
        },
        toggleFilter() {
            if (!this.tfilter) {
                this.tfilter = true;
            } else {
                this.tfilter = false;
            }
        },
        getIcon(value) {
            if (value > 0.0) {
                return 'fas fa-arrow-up'
            } else {
                return 'fas fa-arrow-down'
            }
        },

        ...mapActions('reportList', ['getSalesAnalysis', 'getProduct']),
    },
    computed: {
        ...mapState('reportList', ['dataAnalysis', 'dataProduct']),
        ...mapState('auth', ['userData']),
        ...mapGetters('auth', ['isAuth']),

        minDate() {
            var date = new Date().toISOString()
            if (this.tanggalAwal) {
                date = new Date(this.tanggalAwal).toISOString()
            } else {
                date = new Date("2000-01-01").toISOString()
            }
            return date
        },
        maxDate() {
            var date = new Date().toISOString()
            if (this.tanggalAkhir) {
                date = new Date(this.tanggalAkhir).toISOString()
            }
            return date
        },
    },
    created() {
        this.$store.dispatch('setPageTitle', 'Laporan Penjualan (New)');
        this.params = []
        this.getSalesAnalysis({ params: this.params, dateType: this.tipe.value, productCode: this.product.value })
        this.getProduct({ params: [], page: this.page, limit: 1000 })
    }
};
</script>